const OverrideIcon = props => {
    const overrideIconHeight = 45;
    console.log(props.trendCountries[props.country].icon)
return (
    <div
      style={{
        top: - (overrideIconHeight + props.iconGap),
        height: overrideIconHeight,
        width: overrideIconHeight,
        display: props.zoomedCountry ? "none" : "flex",
      }}
      className="override-icon-single"
      onClick={() => props.markerClickHandler(props.country)}
      onMouseOver={(event) => {
        props.showTooltipHandler(
          props.trendCountries[props.country].countryTitle,
          event,
          props.trendCountries[props.country].content
        );
      }}
      onMouseMove={(event) => props.moveTooltipHandler(event)}
      onMouseOut={props.hideTooltipHandler}
    >
      <img
        style={{ width: "65%", height: "65%" }}
        src={`https://acleddata.com/wp-content/icons/svg/${(props.trendCountries[props.country].icon)}`}
      ></img>
    </div>
)
}

export default OverrideIcon